<script setup lang="ts">
import { TextField } from '@library/Components/Forms/TextField';
import { SectionTitle, useBackButton } from "@app/Components/Utilities";
import { vMaska } from "maska";
import { makeForm } from "@library/Components/Forms/Form";
import { useManageBankAccountViewModel, ManageBankAccountFormState } from '../Types/ManageBankAccountViewModel';

useBackButton();

const viewModel = await useManageBankAccountViewModel();
const model = viewModel.formModel.value;
const formState = viewModel.formState;

const form = makeForm( model );

</script>

<template>
    <Form class="flex flex-col h-full w-full flex-1 justify-start"
          :form="form"
          v-slot="{form}"
          @ok="() => { viewModel.upsertBankAccount(); }">
        <div class="p-3 flex-grow tracking-wider">
            <div class="text-center mt-20 mb-8 px-4">
                <SectionTitle>Bank account details</SectionTitle>
                <p class="text-center">Easily transfer your Cashback balance</p>
                <p class="text-center">Enter your bank details to transfer cash directly to your account</p>
            </div>
            <div class="bg-red-500/20 border border-red-700 rounded p-4 mb-4" 
                 v-if="viewModel.errorState.value">
                An error has occurred, please try again.
            </div>
            <TextField v-model="model.bsb" 
                       label="BSB" 
                       required 
                       :readonly="formState == ManageBankAccountFormState.Readonly" 
                       :rules="formState == ManageBankAccountFormState.AllowInput ? viewModel.validation.bsb : []" 
                       v-maska:[viewModel.maskaOptions.bsb] />
            <TextField v-model="model.accountNumber" 
                       label="Account Number" 
                       required 
                       :readonly="formState == ManageBankAccountFormState.Readonly" 
                       :rules="formState == ManageBankAccountFormState.AllowInput ? viewModel.validation.accountNumber : []" 
                       v-maska:[viewModel.maskaOptions.accountNumber] />
        </div>
        <div class="p-3 mb-4">
            <Button class="w-full mb-3" 
                    variant="outlined" 
                    v-if="formState == ManageBankAccountFormState.Readonly" 
                    @click="() => viewModel.deleteBankAccount()">
                Remove
            </Button>
            <Button class="w-full" 
                    variant="outlined" 
                    v-if="formState == ManageBankAccountFormState.Readonly" 
                    @click="() => viewModel.resetForm( form )">
                Clear
            </Button>
            <Button class="w-full" 
                    variant="flat" 
                    color="secondary" 
                    type="submit" 
                    v-if="formState == ManageBankAccountFormState.AllowInput">
                Save
            </Button>
        </div>
    </Form>
</template>
